import React from 'react';
import Nav from '../../components/Nav/Nav';

const Blog = () => {
    return (
        <div>
            <Nav></Nav>
            <div className="mt-5 container">
                <h1>Blog coming soon...</h1>
            </div>
        </div>
    );
};

export default Blog;